import { React, FelaComponent, PropTypes, InputWrapper, AntInput, AntForm } from '../../dependencies';

import style from './TagListFilter.style';

const AntFormItem = AntForm.Item;

const TagListFilter = ({ onChange, intl }) => (
    <FelaComponent style={style}>
        <InputWrapper>
            <AntFormItem>
                <AntInput
                    placeholder={intl.formatMessage({ id: 'tags.list.filter.placeholder' })}
                    onChange={e => {
                        const { value } = e.target;
                        onChange(value);
                    }}
                />
            </AntFormItem>
        </InputWrapper>
    </FelaComponent>
);

TagListFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    intl: PropTypes.shape().isRequired,
};

export default TagListFilter;
